import { toastAdd } from 'mk2/actions';
import React from 'react';
import { actions as toastrActions } from 'react-redux-toastr';
import { REMOVE_TOASTR } from 'react-redux-toastr/lib/constants';
import { all, put, take, takeEvery } from 'redux-saga/effects';
import UndoToast from './UndoToast';
import {
    UNDO_TOAST_HIDE,
    UNDO_TOAST_SHOW,
    undoToastHidden,
    UndoToastHideAction,
    UndoToastShowAction,
} from './UndoToast.actions';
import { UNDO_TOAST_DELAY } from './UndoToast.constants';

function* showUndo({ message, id }: UndoToastShowAction) {
    yield put(toastAdd('success', id, {
        timeOut: UNDO_TOAST_DELAY,
        removeOnHover: UNDO_TOAST_DELAY / 2,
        component: ({ remove }) => (<UndoToast message={message} undoId={id} remove={remove} />),
    }));

    const { payload } = yield take(REMOVE_TOASTR);

    if (payload === id) {
        yield put(undoToastHidden(id));
    }
}

function* hideUndo({ id }: UndoToastHideAction) {
    yield put(toastrActions.remove(id));
}

export default function* root() {
    yield all([
        // Undo
        takeEvery(UNDO_TOAST_SHOW, showUndo),
        takeEvery(UNDO_TOAST_HIDE, hideUndo),
    ]);
}
